import {
  endOfMonth,
  isAfter,
  isSameMonth,
  startOfMonth,
  startOfYear,
  subMonths,
} from 'date-fns';

// Year range: Jan 1 → end of last complete month (or end of selected month if in the past).
export function getOvertimeDateRange(selectedMonth: Date): {
  startDate: Date;
  endDate: Date;
} {
  const currentMonth = startOfMonth(new Date());
  const selectedMonthStart = startOfMonth(selectedMonth);

  const monthNotFinished =
    isSameMonth(selectedMonthStart, currentMonth) ||
    isAfter(selectedMonthStart, currentMonth);

  const endMonth = monthNotFinished
    ? subMonths(selectedMonthStart, 1)
    : selectedMonthStart;

  const startDate = startOfYear(endMonth);
  const endDate = endOfMonth(endMonth);

  return { startDate, endDate };
}
